import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DepatureboardPageComponent } from './depatureboard-page/depatureboard-page.component';
import { DualBoardComponent } from './dual-board/dual-board.component';

const routes: Routes = [
  { path: '', component: DepatureboardPageComponent },
  { path: 'dual', component: DualBoardComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
